import { APP_VERSION } from '../appVersion';

const SITE = (process.env.REACT_APP_SITE_URL || 'https://yadoo20.ir').replace(/\/+$/, '');
const API  = (process.env.REACT_APP_API_URL  || `${SITE}/api`).replace(/\/+$/, '');
const LS_DISMISS = 'dismissed_app_version';

export const CHECK_INTERVAL = 5 * 60 * 1000;

export function cmpVer(a, b) {
  const pa = String(a || '0').split('.').map(n => parseInt(n, 10) || 0);
  const pb = String(b || '0').split('.').map(n => parseInt(n, 10) || 0);
  for (let i = 0; i < 3; i++) {
    const x = pa[i] || 0, y = pb[i] || 0;
    if (x > y) return 1;
    if (x < y) return -1;
  }
  return 0;
}

export function isAPK() {
  if (typeof window === 'undefined') return false;
  return window.location.protocol === 'file:';
}

function isDev() {
  if (typeof window === 'undefined') return false;
  const h = window.location.hostname;
  return h === 'localhost' || h === '127.0.0.1'
    || /^192\.168\./.test(h) || /^10\./.test(h) || /^172\.(1[6-9]|2\d|3[01])\./.test(h);
}

function isProtectedPath() {
  const p = window.location.pathname;
  return p.startsWith('/payment') || p.startsWith('/exams/take');
}

function absUrl(u) {
  if (!u) return null;
  if (/^https?:\/\//i.test(u)) return u;
  return SITE + (u.startsWith('/') ? u : '/' + u);
}

export async function checkForUpdate() {
  if (isDev()) return null;
  if (isProtectedPath()) return null;

  let user = {};
  try { user = JSON.parse(localStorage.getItem('user') || '{}'); } catch {}
  if (user.role === 'admin') return null;

  try {
    const res = await fetch(`${API}/public/app-update?t=${Date.now()}`, {
      cache: 'no-store',
      headers: { 'Cache-Control': 'no-cache' },
    });
    if (!res.ok) return null;
    const d = await res.json();
    if (!d.active || !d.version) return null;
    if (!/^\d+\.\d+\.\d+/.test(d.version)) return null;

    if (cmpVer(APP_VERSION, d.version) >= 0) return null;
    if (isAPK() && !d.apkUrl) return null;
    if (!d.forceUpdate && sessionStorage.getItem(LS_DISMISS) === d.version) return null;

    return { ...d, apkUrl: absUrl(d.apkUrl) };
  } catch {
    return null;
  }
}

export function dismissUpdate(version) {
  sessionStorage.setItem(LS_DISMISS, version);
}

export function applyWebUpdate() {
  const u = new URL(window.location.href);
  u.searchParams.set('_v', Date.now().toString());
  window.location.href = u.toString();
}

export async function applyApkUpdate(apkUrl) {
  if (!apkUrl) { window.location.href = SITE; return; }

  const filename = apkUrl.split('/').pop() || 'app-update.apk';

  // همان الگوی دانلود PDF در books.jsx — تست‌شده روی WebView
  try {
    const response = await fetch(apkUrl);
    if (!response.ok) throw new Error('network');
    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => window.URL.revokeObjectURL(blobUrl), 1000);
  } catch {
    const a = document.createElement('a');
    a.href = apkUrl;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
}

export function openSiteFallback() {
  window.open(SITE, '_blank', 'noopener,noreferrer');
}

export { APP_VERSION, SITE };